import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { toast } from 'react-toastify';

const AdminLogin = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    // Strict Restrictions: 8+ chars, 1 Upper, 1 Lower, 1 Special, 1 Number
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        
        if (!passwordRegex.test(formData.password)) {
            toast.error("Security Alert: Password must contain 8+ characters, including Uppercase, Lowercase, Number, and Special Character.");
            return;
        }

        setLoading(true);
        try {
            // New dedicated internal login endpoint
            const response = await api.post('/admin/internal-login', formData);
            
            if (response.data.accessToken) {
                // Store token and a specific flag to identify Monospear Internal Staff
                localStorage.setItem('token', response.data.accessToken);
                localStorage.setItem('isInternalAdmin', 'true'); 
                
                toast.success("Monospear Infrastructure Accessed");

                // Immediately land on Template Control Center
                navigate('/sa-ctrl-x9k2', { replace: true });
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Invalid Internal Credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <style>
                {`
                    .admin-input:focus { border-color: #1D5DA8 !important; outline: none; box-shadow: 0 0 0 3px rgba(29, 93, 168, 0.1); }
                    .admin-btn:hover { opacity: 0.9; transform: translateY(-1px); }
                    .admin-btn:active { transform: translateY(0); }
                `}
            </style>

            <div style={styles.card}>
                <div style={styles.header}>
                    <h1 style={styles.brand}>KINEXAR INTERNAL</h1>
                    <p style={styles.subtitle}>Monospear Technologies Infrastructure</p>
                </div>

                <form onSubmit={handleLogin}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Internal Email</label>
                        <input 
                            type="email" 
                            name="email"
                            className="admin-input"
                            placeholder="name@monospear.com"
                            style={styles.input}
                            value={formData.email}
                            onChange={handleChange}
                            required 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Security Password</label>
                        <div style={styles.passwordWrapper}>
                            <input 
                                type={showPassword ? "text" : "password"} 
                                name="password"
                                className="admin-input"
                                placeholder="••••••••"
                                style={styles.input}
                                value={formData.password}
                                onChange={handleChange}
                                required 
                            />
                            <button 
                                type="button" 
                                onClick={() => setShowPassword(!showPassword)}
                                style={styles.eyeBtn}
                            >
                                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                            </button>
                        </div>
                    </div>

                    <button 
                        type="submit" 
                        className="admin-btn"
                        style={loading ? {...styles.button, backgroundColor: '#cbd5e1'} : styles.button} 
                        disabled={loading}
                    >
                        {loading ? "Verifying Credentials..." : "Authenticate & Enter"}
                    </button>
                </form>

                <div style={styles.footer}>
                    <img src="/images/monospear.svg" alt="Monospear" style={styles.logo} />
                    <div style={styles.footerText}>© 2026 Internal Operations</div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: { height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F8FAFC', fontFamily: "'Inter', sans-serif" },
    card: { background: '#ffffff', padding: '40px', borderRadius: '16px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '420px', textAlign: 'center', border: '1px solid #E2E8F0' },
    header: { marginBottom: '32px' },
    brand: { color: '#1D5DA8', fontSize: '24px', fontWeight: '800', letterSpacing: '1.5px', margin: '0 0 8px 0' },
    subtitle: { color: '#64748B', fontSize: '13px', fontWeight: '500', margin: 0 },
    inputGroup: { textAlign: 'left', marginBottom: '20px' },
    label: { display: 'block', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' },
    input: { width: '100%', padding: '12px 16px', border: '1px solid #CBD5E1', borderRadius: '8px', fontSize: '14px', backgroundColor: '#FFFFFF', boxSizing: 'border-box', transition: 'all 0.2s ease' },
    passwordWrapper: { position: 'relative' },
    eyeBtn: { position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: '18px', display: 'flex', alignItems: 'center' },
    button: { width: '100%', padding: '14px', backgroundColor: '#1D5DA8', color: '#FFFFFF', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s ease', marginTop: '10px' },
    footer: { marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #F1F5F9' },
    logo: { height: '18px', opacity: '0.7', marginBottom: '8px' },
    footerText: { fontSize: '10px', color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '1px' }
};

export default AdminLogin;